import React from "react";
import Category from "../common/Category";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useQuery } from "react-query";
import axios from "axios";

const BusinessSearch = React.memo(function BusinessSearch(props) {
  const handleCategoryClick = (event) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const location = useLocation();
  let queryParams = new URLSearchParams(location.search);
  let queryLocation = 1;
  if (queryParams.get("location")) {
    queryLocation = queryParams.get("location");
  }

  const { data: categories, isLoading } = useQuery({
    queryKey: ["businessCategories"],
    queryFn: async () => {
      const response = await axios.request({
        method: "GET",
        url: process.env.REACT_APP_BASE_URL + "/api/categories",
        headers: {
          Authorization: process.env.REACT_APP_API_KEY,
        },
        params: {
          parent: 5,
          page: 1,
          limit: 50,
        },
      });
      return response.data.data;
    },
  });
  // If categories are loading, show skeleton
  if (isLoading) {
    return (
      <>
        <Helmet>
          <title>{`Sahi Search - ${props.pageTitle}`}</title>
          <meta name="description" content="" />
        </Helmet>
        <div className="card category-list hidden-xs hidden-sm">
          <div className="card-body">
            <h6 className="category-list-title">All categories</h6>
            <ul className="list-unstyled">
              {Array.from({ length: 8 }).map((_, index) => (
                <li className="category-list-item" key={`skeleton-${index}`}>
                  <div style={{ padding: "8px 0" }}>
                    <div
                      style={{
                        height: "16px",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "4px",
                        width: "70%",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    ></div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>{`Sahi Search - ${props.pageTitle}`}</title>
        <meta name="description" content="" />
      </Helmet>
      <div className="card category-list hidden-xs hidden-sm">
        <div className="card-body ">
          <h6 className="category-list-title">All categories</h6>
          <ul className="list-unstyled">
            {categories
              ? categories.map((element, index) => {
                  return (
                    <li className="category-list-item" key={"category_" + index}>
                      <Category active={parseInt(props.queryCategory) === parseInt(element.id) ? 1 : 2} categoryId={element.id} category={element.name} count={element.count} to={`/search?category=${element.id}&location=${queryLocation}&page=1&limit=10`} onclick={handleCategoryClick} key={"category_" + index} />
                    </li>
                  );
                })
              : false}
          </ul>
        </div>
      </div>
    </>
  );
});
export default BusinessSearch;
